import { Form } from "antd";
import { TopBox } from "components";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetPropertyDashboardRepairingCategory } from "service/dashboard/property/homecare";
import { LoadingDashboard } from "../..";

const TypeBox = () => {
  const { t } = useTranslation();
  const { findDate } = useOverview();

  const repairTypesDate = Form.useWatch("repairTypesDate");
  const date = findDate(repairTypesDate);

  const query = useGetPropertyDashboardRepairingCategory({ ...date });

  return (
    <LoadingDashboard loading={query.isFetching}>
      <TopBox
        height={350}
        query={query}
        nameDate="repairTypesDate"
        title={t("statistics-type-5-types")}
        translation
        keyTitle="title"
        text={t("times")}
      />
    </LoadingDashboard>
  );
};

export default TypeBox;
